import React, { useState, useRef, useEffect } from 'react';
import AuthApi from '../../service/AuthApi';
import { pushNotification } from '../../utils/notifications';
import ReCAPTCHA from "react-google-recaptcha";

const RegisterForm = () => {
    const [formData, setFormData] = useState({
        accountName: '',
        password: '',
        confirmPassword: '',
        email: '',
        hoTen: '',
        tenCuaHang: '',
        soDienThoai: '',
        diaChi: '',
        goiPhanMemId: 10,
    });
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const recaptchaRef = useRef(null);
    useEffect(() => {
        const originalBodyClass = document.body.className;
        document.body.className = 'vertical-layout vertical-menu 1-column blank-page page-blue';
        return () => {
            document.body.className = originalBodyClass;
        }
    }, []);
    useEffect(() => {
        document.title = "Đăng ký dùng thử | Phần mềm quản lý cầm đồ Morman";
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
        if (name === 'password' || name === 'confirmPassword') {
            if (errors.confirmPassword) setErrors(prev => ({ ...prev, confirmPassword: '' }));
        }
        if (errors.api) {
            setErrors(prev => ({ ...prev, api: '' }));
        }
    };
    const handleRecaptchaChange = (token) => {
        setRecaptchaToken(token);
        if (errors.recaptcha) {
            setErrors(prev => ({ ...prev, recaptcha: '' }));
        }
        if (errors.api) {
            setErrors(prev => ({ ...prev, api: '' }));
        }
    };

    const validateForm = () => {
        let formIsValid = true;
        let newErrors = {};

        if (!formData.accountName.trim()) { newErrors.accountName = 'Vui lòng nhập tên đăng nhập.'; formIsValid = false; }
        if (!formData.password) { newErrors.password = 'Vui lòng nhập mật khẩu.'; formIsValid = false; }
        else if (formData.password.length < 6 || !/\d/.test(formData.password) || !/[a-zA-Z]/.test(formData.password)) {
            newErrors.password = 'Mật khẩu ít nhất 6 ký tự, gồm chữ và số.'; formIsValid = false;
        }
        if (!formData.confirmPassword) { newErrors.confirmPassword = 'Vui lòng nhập lại mật khẩu.'; formIsValid = false; }
        else if (formData.password && formData.confirmPassword && formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Mật khẩu và xác nhận mật khẩu không trùng khớp.';
            formIsValid = false;
        }
        if (!formData.email.trim()) { newErrors.email = 'Vui lòng nhập email.'; formIsValid = false; }
        else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email không đúng định dạng.'; formIsValid = false;
        }
        if (!formData.hoTen.trim()) { newErrors.hoTen = 'Vui lòng nhập họ và tên.'; formIsValid = false; }
        if (!formData.tenCuaHang.trim()) { newErrors.tenCuaHang = 'Vui lòng nhập tên cửa hàng.'; formIsValid = false; }
        if (!formData.soDienThoai.trim()) { newErrors.soDienThoai = 'Vui lòng nhập số điện thoại.'; formIsValid = false; }
        else if (!/^\d{10}$/.test(formData.soDienThoai)) {
            newErrors.soDienThoai = 'Số điện thoại không hợp lệ (cần 10 số).'; formIsValid = false;
        }
        if (!recaptchaToken) { newErrors.recaptcha = 'Vui lòng xác nhận bạn không phải robot.'; formIsValid = false; }

        setErrors(newErrors);
        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});

        if (!validateForm()) {
            const firstErrorField = Object.keys(errors).find(key => errors[key]);
            if (firstErrorField) {
                const element = document.getElementsByName(firstErrorField)[0];
                element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return;
        }
        setIsLoading(true);
        const urlParams = new URLSearchParams(window.location.search);
        const apiData = {
            ...formData,
            RecaptchaToken: recaptchaToken,
            idCs: urlParams.get('idCs'),
            idnv: urlParams.get('idnv')
        };
        try {
            const response = await AuthApi.register(apiData);
            debugger
            if (response && response.status === 200) {
                pushNotification("Đăng ký thành công!", "success", "TOP_CENTER", 3000);
                setTimeout(() => {
                    window.location.href = '/trang-chu.aspx';
                }, 2000);
            } else {
              
                pushNotification(response.data, "error", "TOP_CENTER", 3000);
                if (recaptchaRef.current) recaptchaRef.current.reset();
                setRecaptchaToken(null);
            }
        } catch (err) {
            pushNotification("Có lỗi xảy ra, vui lòng liên hệ hỗ trợ.", "error", "TOP_CENTER", 3000);
            if (recaptchaRef.current) {
                recaptchaRef.current.reset();
            }
            setRecaptchaToken(null);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="content">
            <div className="sign-main content-wrapper">
                <div className="content-header row mb-4"></div>
                <div className="content-body">
                    <section className="flexbox-container form-login">
                        <div className="col-12 d-flex align-items-center justify-content-center">
                            <div className="col-md-3 col-10 box-shadow-2 p-0">
                                <div className="card border-grey border-lighten-3 m-0">
                                    <div className="card-header border-0">
                                        <a href="http://morman.vn/">
                                            <div className="card-title text-center">
                                                <div className="p-1">
                                                    <img src="/app-assets/images/logo/logo-dark.png" alt="logo" />
                                                </div>
                                            </div>
                                            <h5 className="card-subtitle1 text-center"><span>PHẦN MỀM QUẢN LÝ CẦM ĐỒ SỐ 1 VIỆT NAM</span></h5>
                                            <h6 className="card-subtitle line-on-side text-muted text-center mb-1 pt-2">
                                                <span>Đăng ký với MorMan</span>
                                            </h6>
                                        </a>
                                    </div>
                                    <div className="card-content">
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit} noValidate className="form-horizontal form-simple">
                                                <fieldset className="form-group position-relative has-icon-left mb-1">
                                                    <input
                                                        name="accountName"
                                                        type="text"
                                                        value={formData.accountName}
                                                        onChange={handleInputChange}
                                                        className={`form-control ${errors.accountName ? 'is-invalid' : ''}`}
                                                        placeholder="Tên đăng nhập"
                                                        required
                                                    />
                                                    <div className="form-control-position">
                                                        <i className="ft-user"></i>
                                                    </div>
                                                    <div className="invalid-feedback red text-left">{errors.accountName}</div>
                                                </fieldset>
                                                <fieldset className="form-group position-relative has-icon-left mb-1">
                                                    <input
                                                        name="password"
                                                        type="password"
                                                        value={formData.password}
                                                        onChange={handleInputChange}
                                                        className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                                        placeholder="Mật khẩu"
                                                        required
                                                    />
                                                    <div className="form-control-position">
                                                        <i className="la la-key"></i>
                                                    </div>
                                                    <div className="invalid-feedback red text-left">{errors.password}</div>
                                                </fieldset>
                                                <fieldset className="form-group position-relative has-icon-left mb-1">
                                                    <input
                                                        name="confirmPassword"
                                                        type="password"
                                                        value={formData.confirmPassword}
                                                        onChange={handleInputChange}
                                                        className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                                                        placeholder="Xác nhận mật khẩu"
                                                        required
                                                    />
                                                    <div className="form-control-position">
                                                        <i className="la la-key"></i>
                                                    </div>
                                                    <div className="invalid-feedback red text-left">{errors.confirmPassword}</div>
                                                </fieldset>
                                                <fieldset className="form-group position-relative has-icon-left mb-1">
                                                    <input
                                                        name="email"
                                                        type="email"
                                                        value={formData.email}
                                                        onChange={handleInputChange}
                                                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                        placeholder="Email"
                                                        required
                                                    />
                                                    <div className="form-control-position">
                                                        <i className="ft-mail"></i>
                                                    </div>
                                                    <div className="invalid-feedback red text-left">{errors.email}</div>
                                                </fieldset>
                                                <fieldset className="form-group position-relative has-icon-left mb-1">
                                                    <input
                                                        name="hoTen"
                                                        type="text"
                                                        value={formData.hoTen}
                                                        onChange={handleInputChange}
                                                        className={`form-control ${errors.hoTen ? 'is-invalid' : ''}`}
                                                        placeholder="Họ và tên"
                                                        required
                                                    />
                                                    <div className="form-control-position">
                                                        <i className="ft-user"></i>
                                                    </div>
                                                    <div className="invalid-feedback red text-left">{errors.hoTen}</div>
                                                </fieldset>
                                                <fieldset className="form-group position-relative has-icon-left mb-1">
                                                    <input
                                                        name="tenCuaHang"
                                                        type="text"
                                                        value={formData.tenCuaHang}
                                                        onChange={handleInputChange}
                                                        className={`form-control ${errors.tenCuaHang ? 'is-invalid' : ''}`}
                                                        placeholder="Tên cửa hàng"
                                                        required
                                                    />
                                                    <div className="form-control-position">
                                                        <i className="la la-institution"></i>
                                                    </div>
                                                    <div className="invalid-feedback red text-left">{errors.tenCuaHang}</div>
                                                </fieldset>
                                                <fieldset className="form-group position-relative has-icon-left mb-1">
                                                    <input
                                                        name="soDienThoai"
                                                        type="tel"
                                                        value={formData.soDienThoai}
                                                        onChange={handleInputChange}
                                                        className={`form-control ${errors.soDienThoai ? 'is-invalid' : ''}`}
                                                        placeholder="Số điện thoại"
                                                        required
                                                    />
                                                    <div className="form-control-position">
                                                        <i className="ft-phone-call"></i>
                                                    </div>
                                                    <small className="form-text text-muted text-left mt-1" style={{ fontSize: '12px', fontStyle: 'italic', color: '#626262' }}>
                                                        *Vui lòng nhập đúng số điện thoại để được hỗ trợ kích hoạt tài khoản nhanh nhất*
                                                    </small>
                                                    <div className="invalid-feedback red text-left">{errors.soDienThoai}</div>
                                                </fieldset>
                                                <fieldset className="form-group position-relative has-icon-left mb-1">
                                                    <input
                                                        name="diaChi"
                                                        type="text"
                                                        value={formData.diaChi}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                        placeholder="Địa chỉ"
                                                    />
                                                    <div className="form-control-position">
                                                        <i className="la la-home"></i>
                                                    </div>
                                                </fieldset>
                                                <div className="d-flex justify-content-center my-1">
                                                    <ReCAPTCHA
                                                        ref={recaptchaRef}
                                                        sitekey="6LclF-ggAAAAAPseVHjTInekDYaYruu3YFJ24y_P"
                                                        onChange={handleRecaptchaChange}
                                                        onExpired={() => { setRecaptchaToken(null); setErrors(prev => ({ ...prev, recaptcha: 'Mã CAPTCHA đã hết hạn.' })); }}
                                                    />
                                                </div>
                                                <button
                                                    type="submit"
                                                    className="btn btn-info btn-lg btn-block"
                                                    disabled={isLoading}
                                                >
                                                    {isLoading ? (
                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    ) : (
                                                        <i className="ft-unlock"></i>
                                                    )}
                                                    {isLoading ? ' Đang xử lý...' : ' Đăng ký'}
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                    <p className="text-center text-muted">
                                        Bạn đã có tài khoản?{' '}
                                        <a href="/dang-nhap.aspx" className="card-link blue">Đăng nhập</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default RegisterForm;